import ParagraphTag from "../../reusebale/Paragraph";
import ImageTag from "../../reusebale/imageTag";
// import SuccessPopup from "../../popup/success";
import { useSelector } from "react-redux";

const PlanSection = ({ onButtonClick, isComplete }) => {
  const { userCompleteProfile } = useSelector((state) => state.auth);

  return (
    <div>
      <div className="bg-white rounded-2xl py-5 px-4 w-full mt-6 shadow-md shadow-gray-200 transition-all duration-300 hover:opacity-90">
        <div
          className="w-[95%] mx-auto mt-3"
          onClick={() => onButtonClick("Personal Information")}
        >
          <div className="bg-[#E6BF9F1A] hover:border-2 hover:border-themeColor cursor-pointer transition-all duration-100 ease-in-out rounded-lg flex items-center py-2">
            <div className="w-[5%] flex justify-center">
              <ImageTag
                path="/assets/daashboard/profile-complete/caret-right.png"
                classes="w-[6px]"
                altText="caret-right"
              />
            </div>
            <div className="w-[85%] flex items-center">
              <ImageTag
                path={"/assets/daashboard/profile-complete/user-icon.png"}
                classes="w-[40px]"
                altText="plan-image"
              />
              <ParagraphTag
                content={"Personal Information"}
                classes="text-darkColor font-popinsSemiBold text-sm pl-3"
              />
            </div>
            <div className="w-[10%] flex justify-center">
              <input
                type="checkbox"
                checked={
                  userCompleteProfile?.personalInformation ? true : false
                }
                readOnly
                className="h-6 w-6 rounded-full border-2 border-statusColor bg-white checked:bg-statusColor checked:border-statusColor focus:ring-statusColor cursor-pointer"
              />
            </div>
          </div>
        </div>

        <div
          className="w-[95%] mx-auto mt-3"
          onClick={() => onButtonClick("Company Information")}
        >
          <div className="bg-[#E6BF9F1A] hover:border-2 hover:border-themeColor cursor-pointer transition-all duration-100 ease-in-out rounded-lg flex items-center py-2">
            <div className="w-[5%] flex justify-center">
              <ImageTag
                path="/assets/daashboard/profile-complete/caret-right.png"
                classes="w-[6px]"
                altText="caret-right"
              />
            </div>
            <div className="w-[85%] flex items-center">
              <ImageTag
                path={"/assets/daashboard/profile-complete/beg-icon.png"}
                classes="w-[40px]"
                altText="plan-image"
              />
              <ParagraphTag
                content={"Company Information"}
                classes="text-darkColor font-popinsSemiBold text-sm pl-3"
              />
            </div>
            <div className="w-[10%] flex justify-center">
              <input
                type="checkbox"
                checked={userCompleteProfile?.companyInformation ? true : false}
                readOnly
                className="h-6 w-6 rounded-full border-2 border-statusColor bg-white checked:bg-statusColor checked:border-statusColor focus:ring-statusColor cursor-pointer"
              />
            </div>
          </div>
        </div>

        {/* <div
          className="w-[95%] mx-auto mt-3"
          onClick={() => onButtonClick("Bank Account")}
        >
          <div className="bg-[#E6BF9F1A] hover:border-2 hover:border-themeColor cursor-pointer transition-all duration-100 ease-in-out rounded-lg flex items-center py-2">
            <div className="w-[5%] flex justify-center">
              <ImageTag
                path="/assets/daashboard/profile-complete/caret-right.png"
                classes="w-[6px]"
                altText="caret-right"
              />
            </div>
            <div className="w-[85%] flex items-center">
              <ImageTag
                path={"/assets/daashboard/profile-complete/card-icon.png"}
                classes="w-[40px]"
                altText="plan-image"
              />
              <ParagraphTag
                content={"Bank Account"}
                classes="text-darkColor font-popinsSemiBold text-sm pl-3"
              />
            </div>
            <div className="w-[10%] flex justify-center">
              <input
                type="checkbox"
                checked={userCompleteProfile?.bankInformation ? true : false}
                readOnly
                className="h-6 w-6 rounded-full border-2 border-statusColor bg-white checked:bg-statusColor checked:border-statusColor focus:ring-statusColor cursor-pointer"
              />
            </div>
          </div>
        </div> */}

        {/* <div
          className="w-[95%] mx-auto mt-3"
          onClick={() => onButtonClick("Sign Lease")}
        >
          <div className="bg-[#E6BF9F1A] hover:border-2 hover:border-themeColor cursor-pointer transition-all duration-100 ease-in-out rounded-lg flex items-center py-2">
            <div className="w-[5%] flex justify-center">
              <ImageTag
                path="/assets/daashboard/profile-complete/caret-right.png"
                classes="w-[6px]"
                altText="caret-right"
              />
            </div>
            <div className="w-[85%] flex items-center">
              <ImageTag
                path={"/assets/daashboard/profile-complete/note-icon.png"}
                classes="w-[40px]"
                altText="plan-image"
              />
              <ParagraphTag
                content={"Sign Lease"}
                classes="text-darkColor font-popinsSemiBold text-sm pl-3"
              />
            </div>
            <div className="w-[10%] flex justify-center">
              <input
                type="checkbox"
                checked={false}
                readOnly
                className="h-6 w-6 rounded-full border-2 border-statusColor bg-white checked:bg-statusColor checked:border-statusColor focus:ring-statusColor cursor-pointer"
              />
            </div>
          </div>
        </div> */}
      </div>
      <div className="w-[20%] mt-6">
        {/* <ButtonTag
          onSubmit={() => isComplete("Complete Profile")}
          name={completeProfileData.approval}
          classes="text-sm text-center bg-themeColor text-white"
        /> */}
      </div>
    </div>
  );
};

export default PlanSection;
